export const COOKIE_NAME = {
  TOKEN: 'e-work-token',
};

export const LOCAL_STORAGE_NAME = {
  URL_REDIRECT: 'url_redirect',
};
